//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast, ActivityIndicator } from 'mand-mobile'

export default {
  name: 'ToastLoading',
  components: {
    [Toast.component.name]: Toast.component,
    [ActivityIndicator.name]: ActivityIndicator
  },
  data() {
    return {
      isShow: false
    }
  },
  methods: {
    show() {
      this.$refs.toast.show()
      this.isShow = true
    },
    hide() {
      this.$refs.toast.hide()
      this.isShow = false
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/loading/loading.vue